export const UserLocalStorageKeys = {
  ID: 'id',
  ROLE: 'role',
  EMAIL: 'email',
  VIDEOS_HISTORY_ENABLED: 'videos-history-enabled',
  USERNAME: 'username',
  NSFW_POLICY: 'nsfw_policy',
  WEBTORRENT_ENABLED: 'peertube-videojs-' + 'webtorrent_enabled',
  AUTO_PLAY_VIDEO: 'auto_play_video',
  SESSION_STORAGE_AUTO_PLAY_NEXT_VIDEO: 'auto_play_next_video',
  AUTO_PLAY_VIDEO_PLAYLIST: 'auto_play_video_playlist',
  THEME: 'theme',
  LAST_ACTIVE_THEME: 'last_active_theme',
  VIDEO_LANGUAGES: 'video_languages'
}
